export enum PaymentEngagementType {
  // The type of engagement for which the payment method is used
  Fte = "fte",
  Contractor = "contractor",
  Combined = "combined",
}
